import { log } from 'app/lib/monitoring';
import { getCurrentScreenName } from 'app/lib/root-navigation';
import type { RequestInterceptor } from '../types';
import { MAGENTA, RESET } from 'app/utils/performance/use-screen-perf-monitor';

export const logging: RequestInterceptor = (config) => {
  if (__DEV__) {
    const focusedScreen = getCurrentScreenName() ?? 'unknown';
    const focusedTag = `${MAGENTA}[focused=${focusedScreen}]${RESET}`;
    log(`${config.method?.toUpperCase() ?? 'GET'} ${config.url ?? '/'} ${focusedTag}`);
  }
  return config;
};
